import type { CockpitConfig } from '@/api/types'

type Links = CockpitConfig['links'] | undefined

/** External links are built from the API configuration so environments differ only in appsettings. */
export const links = {
  hotelBackoffice: (links: Links, hotelId: number) => (links?.backoffice ? `${links.backoffice}search#/?q=H${hotelId}&c=HotelsAndChains` : undefined),
  hotelSynchronizations: (links: Links, hotelId: number) => (links?.rateScreenerConfigurationApi ? `${links.rateScreenerConfigurationApi}synchronizations/${hotelId}` : undefined),
  grafanaSynchronization: (links: Links, rateScreenerSynchronizationId: string, hotelId: number) =>
    links?.grafanaSynchronizationDetail ? `${links.grafanaSynchronizationDetail}?var-rssynchronization=${rateScreenerSynchronizationId}&var-hotelId=${hotelId}` : undefined,
  grafanaPos: (links: Links, posName: string) => (links?.grafanaPosDashboard ? `${links.grafanaPosDashboard}&var-pos=${encodeURIComponent(posName)}` : undefined),
  grafanaSentinelSite: (links: Links, site: string) => links?.grafanaSentinelSites?.[site.toLowerCase()],
  // Bugsnag derives project slugs from names: "RateScreener / Monitor" becomes ratescreener-slash-monitor.
  bugsnagProject: (links: Links, projectName: string, slug?: string) =>
    links?.bugsnag
      ? `${links.bugsnag}${slug ?? projectName.toLowerCase().replaceAll('/', '-slash-').replaceAll('.', '-dot-').replace(/[^a-z0-9-]+/g, '-').replace(/-{2,}/g, '-').replace(/^-|-$/g, '')}`
      : undefined,
  googleHotelSearch:(competitorName: string, posUri: string | null) => {
    const host = posUri?.replace(/^(https?:\/\/)?(www\.)?/i, '') ?? ''
    return `https://www.google.com/search?q=Hotel+${encodeURIComponent(competitorName)}${host ? `+site:${encodeURIComponent(host)}` : ''}`
  },
}
